<template>
  <div class="header-box">
    <div class="header-center">
      <router-link to="/">  <img class="logo" src="@/assets/imgs/common/logo.png" /></router-link>
      <div class="menu-ul mod-header">
        <router-link :class="{'menu-item':menuIndex==1}" to="/solution" class="has-sub more">
          解决方案
          <ul class="sub-nav" style="display: none; top: 104px; opacity: 0">
            <li>
              <router-link to="/solution?index=index1" class="s_btn">行业挑战</router-link>
            </li>
            <li>
              <router-link to="/solution?index=index2" class="s_btn">方案优势</router-link>
            </li>
            <li>
              <router-link to="/solution?index=index3" class="s_btn">方案价值</router-link>
            </li>
          </ul>
        </router-link>
        <router-link :class="{'menu-item':menuIndex==2}" to="/product" class="has-sub more"> 产品中心

          <ul class="sub-nav" style="display: none; top: 104px; opacity: 0;width: 220px;left: -80px">
            <li>
              <router-link to="/product?index=1" class="s_btn">预应力工程全数量检测系统</router-link>
            </li>
            <li>
              <router-link to="/product?index=2" class="s_btn">锚下预应力检测系统</router-link>
            </li>
            <li>
              <router-link to="/product?index=3" class="s_btn">预应力锚索基础试验系统</router-link>
            </li>
            <li>
              <router-link to="/product?index=4" class="s_btn">智能拉拔系统</router-link>
            </li>
            <li>
              <router-link to="/product?index=5" class="s_btn">远程监测系统</router-link>
            </li>
          </ul>
        </router-link>
        <router-link :class="{'menu-item':menuIndex==3}" to="/technological">技术创新</router-link>
        <router-link :class="{'menu-item':menuIndex==4}" to="/case" class="has-sub more">典型案例
          <ul class="sub-nav" style="display: none; top: 104px; opacity: 0;">
            <li>
              <router-link to="/case?index=4" class="s_btn">高速公路</router-link>
            </li>
            <li>
              <router-link to="/case?index=1" class="s_btn">软岩隧道</router-link>
            </li>
            <li>
              <router-link to="/case?index=2" class="s_btn">铁路桥梁</router-link>
            </li>
            <li>
              <router-link to="/case?index=3" class="s_btn">特殊桥梁</router-link>
            </li>
            <li>
              <router-link to="/case?index=5" class="s_btn">边坡工程</router-link>
            </li>
            <li>
              <router-link to="/case?index=6" class="s_btn">基坑工程</router-link>
            </li>
          </ul>
        </router-link>
<!--        <router-link :class="{'menu-item':menuIndex==5}" to="/news">新闻中心</router-link>-->
        <router-link :class="{'menu-item':menuIndex==7}" to="/dataCenter" class="has-sub more">技术支持
        </router-link>
        <router-link :class="{'menu-item':menuIndex==6}"  class="has-sub more" to="">关于交达
        <ul class="sub-nav" style="display: none; top: 104px; opacity: 0;">
          <li>
            <router-link to="/inRegard" :class="{'menu-items':menuIndex==6}" class="s_btn">关于交达</router-link>
          </li>
        </ul>
        </router-link>
<!--        <router-link :class="{'menu-item':menuIndex==7}" to="">用户服务</router-link>-->
        <router-link :class="{'menu-item':menuIndex==8||menuIndex==9}"  class="has-sub more" to="">
          联系我们
          <ul class="sub-nav" style="display: none; top: 104px; opacity: 0;">
            <li>
              <router-link to="/contactUs"  :class="{'menu-items':menuIndex==8}" class="s_btn">联系我们</router-link>
            </li>
            <li>
              <router-link to="/joinUs" :class="{'menu-items':menuIndex==9}" class="s_btn">加入我们</router-link>
            </li>
          </ul>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  export default {
    name: 'header',
    props:['menuIndex'],
    data() {
      return {

      }
    },
    mounted() {
      $(function() {
        var fadetimeM;
        $(".mod-header .has-sub").hover(function() {
          var $this = $(this);
          var t = $(".mod-header").height() - $this.position().top + 20;
          clearTimeout(fadetimeM);
          $this.find(".trigger").addClass("open");
          $this.siblings(".has-sub").find(".trigger").removeClass("open");
          $this.find(".sub-nav").stop().show().animate({
            "top": t,
            "opacity": "1"
          }, 200).css({
            "flter": "Alpha(Opacity=100)"
          });
          $this.siblings(".has-sub").find(".sub-nav").stop().animate({
            "top": t + 40,
            "opacity": "0"
          }, 200, function() {
            $(this).hide();
          }).css({
            "flter": "Alpha(Opacity=0)"
          });
        }, function() {
          var $this = $(this);
          var t = $(".mod-header").height() - $this.position().top;
          fadetimeM = setTimeout(function() {
            $this.find(".trigger").removeClass("open");
            $this.find(".sub-nav").stop().animate({
              "top": t + 40,
              "opacity": "0"
            }, 200, function() {
              $(this).hide();
            }).css({
              "flter": "Alpha(Opacity=0)"
            });
          }, 300);
        });

      });
    },
    methods: {

    },
  }
</script>
<style scoped>
  .sub-nav {
    opacity: 0;
    display: none;
    filter: alpha(opacity=0);
    position: absolute;
    top: 104px;
    width: 75px;
    border-radius: 10px;
    left: -25%;
    padding: 20px;
    background: #f9f9f9;
    z-index: 1000;
  }

  .sub-nav li{
    margin-bottom: 20px;
    display: block;
  }
  .sub-nav .s_btn{
    /*color: rgba(25, 32, 59, 1) !important;*/
  }
  .sub-nav li:last-child{
    margin-bottom: 0;
  }
  .sub-nav a{
    margin-left: 0 !important;
  }
  .header-box .menu-ul .has-sub{
    position: relative;
  }
  .menu-item{
    color: #0071EF !important;
    position: relative;
  }
  .menu-items{
    color: #0071EF !important;
    position: relative;
  }
  .menu-item:after{
    content: " ";
    height: 4px;
    width: 110%;
    position: absolute;
    background: #0071EF;
    left: -2%;
    top: 47px;
  }
  .header-box{
    width: 100%;
    height: 80px;
    box-shadow: 0px 20px 200px 1px rgba(0,0,0,0.0500);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    background: #FFFFFF;
    left: 0;
    z-index: 99;
    color: #19203B;
  }

  .header-box .header-center{
    width: 1200px;
    margin: 0 auto;
    display: flex;
  }
  .header-box .logo{
    width: 180px;
  }
  .header-box .menu-ul{
    display: flex;
    align-items: center;
  }
  .header-box .menu-ul a{
    margin-right: 40px;
    font-size: 18px;
    font-weight: bold;
    text-decoration:none;
    color: #000000;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    cursor: pointer;
  }
  .header-box .menu-ul a:nth-child(1){
    margin-left: 120px;
  }
  .header-box .menu-ul a:last-child{
    margin-right: 0;
  }
  .header-box .menu-ul a:hover{
    color: #0071EF;
  }
</style>



// WEBPACK FOOTER //
// src/components/header1.vue